module.exports = __webpack_public_path__ + "img/logo2.1aef7cc1.png";